import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FormViewerService } from '@hff/form-viewer';
import {
  BaseSiteToBrandService,
  CookieService,
  CookiesGroups,
  DataLayerService,
  ExactagService,
  JsonLDService,
} from 'haba-base-components';
import { PrefixboxService } from 'haba-emporix';
import { distinctUntilChanged, filter, switchMap, take, tap } from 'rxjs/operators';
import { build_time } from '../buildInfo';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  private hasNotAcceptedConsent$ = this.cookieService.haveConsentFor$.pipe(
    filter((consent) => Boolean(consent) && !consent?.includes(CookiesGroups.TargetingCookies))
  );
  private hasConsent$ = this.cookieService.haveConsentFor$.pipe(
    filter((consent) => consent?.includes(CookiesGroups.TargetingCookies)),
    distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b))
  );

  constructor(
    private brand: BaseSiteToBrandService,
    private dataLayerService: DataLayerService,
    private cookieService: CookieService,
    private router: Router,
    private prefixboxService: PrefixboxService,
    private exactagService: ExactagService,
    public jsonLdService: JsonLDService
  ) {}

  initThirdPartyServices(): void {
    this.hasNotAcceptedConsent$.pipe(take(1)).subscribe(() => {
      this.exactagService.initExactag(environment.exactag);
    });

    this.hasConsent$
      .pipe(
        take(1),
        tap(() => this.dataLayerService.addInitialDataLayerData()),
        switchMap(() => this.brand.currentCountryCode())
      )
      .subscribe((countryCode) => {
        this.exactagService.initExactag(environment.exactag);
        this.prefixboxService.initScript(countryCode);

        if (this.router.url !== '/') {
          this.dataLayerService.setDataLayer(this.router.url);
        }
      });

    this.brand
      .currentCountryCode()
      .pipe(take(1))
      .subscribe((country) => {
        this.dataLayerService.initGTM(country, environment.gtm);

        country = country.toLowerCase();
        this.jsonLdService.insertWebPageSchema('', environment.jsonLdSchema, country, build_time);
      });

    FormViewerService.init(
      environment.formViewer.backendUrl,
      environment.formViewer.defaultStylesheetUrl
    );
  }
}
